// @ts-strict-ignore
import {Directive, ElementRef, Input, SimpleChanges} from "@angular/core";

@Directive({
	selector: "[appAmplitude]",
	standalone: false,
})
export class AmplitudeDirective {
	@Input() ampValue: number;
	private nativeElement;

	constructor(readonly element: ElementRef) {
		this.nativeElement = element.nativeElement;
		$(this.nativeElement).append("<div class='sliderAmplitude' style='width: 0'></div>");
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes["ampValue"].previousValue !== changes["ampValue"].currentValue) {
			this.changeAmp();
		}
	}

	private changeAmp() {
		$(this.nativeElement).children(".sliderAmplitude")[0].style.width = this.ampValue + "%";
	}
}
